import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { MapWiget } from "../../components";
import { Card, CardContent } from "@material-ui/core";
import { userService } from "../../services/userService";

const styles = (theme) => ({
  root: {
    padding: theme.spacing(0),
    paddingTop: theme.spacing(0),
    height: "calc(100% - 60px)",
  },
  content: {
    marginTop: theme.spacing(0),
    height: "100%",
  },
  bodyContent: {
    height: "100%",
    padding: 2,
    paddingBottom: "0 !important",
  },
});
const dataStructure = {
  memberId: "", // username
  pagination: {
    pages: 20,
    index: 1,
  },
  properties: [
    {
      id: 100,
      longitude: 106.62900924676347,
      latitude: 10.799077812112214,
      toolTip: "1,565,250,000 VND",
      data: {
        title:
          "Căn nhà tọa lạc tại số 106/01/12/17 Đình Nghi Xuân, khu phố 3, Phường Bình Trị Đông, Quận Bình Tân, TP.HCM",
        subTitle: "1,565,250,000 VND",
        imageUrl: `/images/house.png`,
        positions: [
          { longitude: 106.62197113032887, latitude: 10.80986938138075, id: 1 },
          {
            longitude: 106.61733627315111,
            latitude: 10.790983880706797,
            id: 2,
          },
          { longitude: 106.6463470458459, latitude: 10.788791736768285, id: 3 },
          { longitude: 106.6578483580916, latitude: 10.807002908621325, id: 4 },
          { longitude: 106.62197113032887, latitude: 10.8098693813807, id: 5 },
        ],
        lables: [
          {
            title: "Địa chỉ",
            description: "75/27, , Nguyễn Sỹ Sách, TÂN BÌNH, HỒ CHÍ MINH",
          },
          { title: "Loại", description: "Nhà hẻm 8(m)" },
          { title: "Diện tích đất", description: "52" },
          { title: "Diện tích sử dụng", description: "277,7" },
          { title: "Đơn giá đất", description: "81,000,000 VND / m2" },
          { title: "Tính thanh khoản", description: "Trung bình" },
          { title: "Nhân viên thẩm định", description: "Nguyễn Hồ TY Ngân" },
          {
            title: "Đơn vị thẩm định",
            description: "THẨM ĐỊNH GIÁ KHU VỰC TEE",
          },
          { title: "Ngày thẩm định", description: "30/5/2019" },
        ],
        urls: [
          { title: "Hồ sơ", url: "http://tinhocanhminh.com.vn" },
          { title: "Báo cáo thẩm định", url: "http://tinhocanhminh.com.vn" },
        ],
      },
      iconUrl: "/images/markers/mainMarker.png",
      showMarker: true,
    },

    {
      id: 1,
      longitude: 106.6812864995,
      latitude: 10.7800750943,
      toolTip: "1,565,250,000 VND",
      data: {
        title:
          "Căn nhà tọa lạc tại số 106/01/12/17 Đình Nghi Xuân, khu phố 3, Phường Bình Trị Đông, Quận Bình Tân, TP.HCM",
        subTitle: "1,565,250,000 VND",
        imageUrl: `/images/house.png`,
        positions: [
          {
            longitude: 106.681000046,
            latitude: 10.7801985167,
            id: 1,
          },
          {
            longitude: 106.6811365205,
            latitude: 10.7805398089,
            id: 2,
          },
          {
            longitude: 106.6816582921,
            latitude: 10.7802626826,
            id: 3,
          },
          {
            longitude: 106.6814541286,
            latitude: 10.779831854,
            id: 4,
          },
        ],
        lables: [
          {
            title: "Địa chỉ",
            description: "75/27, , Nguyễn Sỹ Sách, TÂN BÌNH, HỒ CHÍ MINH",
          },
          {
            title: "Loại",
            description: "Nhà hẻm 8(m)",
          },
          {
            title: "Diện tích đất",
            description: "52",
          },
          {
            title: "Diện tích sử dụng",
            description: "277,7",
          },
          {
            title: "Đơn giá đất",
            description: "81,000,000 VND / m2",
          },
          {
            title: "Tính thanh khoản",
            description: "Trung bình",
          },
          {
            title: "Nhân viên thẩm định",
            description: "Nguyễn Hồ TY Ngân",
          },
          {
            title: "Đơn vị thẩm định",
            description: "THẨM ĐỊNH GIÁ KHU VỰC TEE",
          },
          {
            title: "Ngày thẩm định",
            description: "30/5/2019",
          },
        ],
        urls: [
          {
            title: "Hồ sơ",
            url: "http://tinhocanhminh.com.vn",
          },
          {
            title: "Báo cáo thẩm định",
            url: "http://tinhocanhminh.com.vn",
          },
        ],
      },
      iconUrl:
        "https://map-api.tinhocanhminh.com.vn/static/v1/images/markers/houseMarker.png",
      showMarker: true,
    },
    {
      id: 2,
      longitude: 106.6904381967,
      latitude: 10.7771345602,
      toolTip: "1,565,250,000 VND",
      data: {
        title:
          "Căn nhà tọa lạc tại số 106/01/12/17 Đình Nghi Xuân, khu phố 3, Phường Bình Trị Đông, Quận Bình Tân, TP.HCM",
        subTitle: "1,565,250,000 VND",
        imageUrl: `/images/house.png`,
        positions: [
          {
            longitude: 106.6901936212,
            latitude: 10.7773440426,
            id: 1,
          },
          {
            longitude: 106.6903550943,
            latitude: 10.777510221,
            id: 2,
          },
          {
            longitude: 106.6907741554,
            latitude: 10.7771627569,
            id: 3,
          },
          {
            longitude: 106.6905973039,
            latitude: 10.776966364,
            id: 4,
          },
        ],
        lables: [
          {
            title: "Địa chỉ",
            description: "75/27, , Nguyễn Sỹ Sách, TÂN BÌNH, HỒ CHÍ MINH",
          },
          {
            title: "Loại",
            description: "Nhà hẻm 8(m)",
          },
          {
            title: "Diện tích đất",
            description: "52",
          },
          {
            title: "Diện tích sử dụng",
            description: "277,7",
          },
          {
            title: "Đơn giá đất",
            description: "81,000,000 VND / m2",
          },
          {
            title: "Tính thanh khoản",
            description: "Trung bình",
          },
          {
            title: "Nhân viên thẩm định",
            description: "Nguyễn Hồ TY Ngân",
          },
          {
            title: "Đơn vị thẩm định",
            description: "THẨM ĐỊNH GIÁ KHU VỰC TEE",
          },
          {
            title: "Ngày thẩm định",
            description: "30/5/2019",
          },
        ],
        urls: [
          {
            title: "Hồ sơ",
            url: "http://tinhocanhminh.com.vn",
          },
          {
            title: "Báo cáo thẩm định",
            url: "http://tinhocanhminh.com.vn",
          },
        ],
      },
      iconUrl:
        "https://map-api.tinhocanhminh.com.vn/static/v1/images/markers/houseMarker.png",
      showMarker: true,
    },
    {
      id: 3,
      longitude: 106.6900626874,
      latitude: 10.776765674,
      toolTip: "1,565,250,000 VND",
      data: {
        title:
          "Căn nhà tọa lạc tại số 106/01/12/17 Đình Nghi Xuân, khu phố 3, Phường Bình Trị Đông, Quận Bình Tân, TP.HCM",
        subTitle: "1,565,250,000 VND",
        imageUrl: `/images/house.png`,
        positions: [
          {
            longitude: 106.6897347741,
            latitude: 10.7769908148,
            id: 1,
          },
          {
            longitude: 106.690203253,
            latitude: 10.7765144504,
            id: 2,
          },
          {
            longitude: 106.6905073534,
            latitude: 10.7765144504,
            id: 3,
          },
          {
            longitude: 106.6900717502,
            latitude: 10.7773056994,
            id: 4,
          },
        ],
        lables: [
          {
            title: "Địa chỉ",
            description: "75/27, , Nguyễn Sỹ Sách, TÂN BÌNH, HỒ CHÍ MINH",
          },
          {
            title: "Loại",
            description: "Nhà hẻm 8(m)",
          },
          {
            title: "Diện tích đất",
            description: "52",
          },
          {
            title: "Diện tích sử dụng",
            description: "277,7",
          },
          {
            title: "Đơn giá đất",
            description: "81,000,000 VND / m2",
          },
          {
            title: "Tính thanh khoản",
            description: "Trung bình",
          },
          {
            title: "Nhân viên thẩm định",
            description: "Nguyễn Hồ TY Ngân",
          },
          {
            title: "Đơn vị thẩm định",
            description: "THẨM ĐỊNH GIÁ KHU VỰC TEE",
          },
          {
            title: "Ngày thẩm định",
            description: "30/5/2019",
          },
        ],
        urls: [
          {
            title: "Hồ sơ",
            url: "http://tinhocanhminh.com.vn",
          },
          {
            title: "Báo cáo thẩm định",
            url: "http://tinhocanhminh.com.vn",
          },
        ],
      },
      iconUrl:
        "https://map-api.tinhocanhminh.com.vn/static/v1/images/markers/houseMarker.png",
      showMarker: true,
    },
    {
      id: 4,
      longitude: 106.6908780789,
      latitude: 10.7775666835,
      toolTip: "1,565,250,000 VND",
      data: {
        title:
          "Căn nhà tọa lạc tại số 106/01/12/17 Đình Nghi Xuân, khu phố 3, Phường Bình Trị Đông, Quận Bình Tân, TP.HCM",
        subTitle: "1,565,250,000 VND",
        imageUrl: `/images/house.png`,
        positions: [
          {
            longitude: 106.6906824953,
            latitude: 10.7777720569,
            id: 1,
          },
          {
            longitude: 106.6910092861,
            latitude: 10.7774472538,
            id: 2,
          },
          {
            longitude: 106.6911323132,
            latitude: 10.7775983251,
            id: 3,
          },
          {
            longitude: 106.6908324346,
            latitude: 10.7778929138,
            id: 4,
          },
        ],
        lables: [
          {
            title: "Địa chỉ",
            description: "75/27, , Nguyễn Sỹ Sách, TÂN BÌNH, HỒ CHÍ MINH",
          },
          {
            title: "Loại",
            description: "Nhà hẻm 8(m)",
          },
          {
            title: "Diện tích đất",
            description: "52",
          },
          {
            title: "Diện tích sử dụng",
            description: "277,7",
          },
          {
            title: "Đơn giá đất",
            description: "81,000,000 VND / m2",
          },
          {
            title: "Tính thanh khoản",
            description: "Trung bình",
          },
          {
            title: "Nhân viên thẩm định",
            description: "Nguyễn Hồ TY Ngân",
          },
          {
            title: "Đơn vị thẩm định",
            description: "THẨM ĐỊNH GIÁ KHU VỰC TEE",
          },
          {
            title: "Ngày thẩm định",
            description: "30/5/2019",
          },
        ],
        urls: [
          {
            title: "Hồ sơ",
            url: "http://tinhocanhminh.com.vn",
          },
          {
            title: "Báo cáo thẩm định",
            url: "http://tinhocanhminh.com.vn",
          },
        ],
      },
      iconUrl:
        "https://map-api.tinhocanhminh.com.vn/static/v1/images/markers/houseMarker.png",
      showMarker: true,
    },
    {
      id: 5,
      longitude: 106.6823915696,
      latitude: 10.7775456043,
      toolTip: "1,565,250,000 VND",
      data: {
        title:
          "Căn nhà tọa lạc tại số 106/01/12/17 Đình Nghi Xuân, khu phố 3, Phường Bình Trị Đông, Quận Bình Tân, TP.HCM",
        subTitle: "1,565,250,000 VND",
        imageUrl: `/images/house.png`,
        positions: [
          {
            longitude: 106.6821503843,
            latitude: 10.7777285152,
            id: 1,
          },
          {
            longitude: 106.6822560262,
            latitude: 10.7779037854,
            id: 2,
          },
          {
            longitude: 106.6826832893,
            latitude: 10.7776547172,
            id: 3,
          },
          {
            longitude: 106.6825752997,
            latitude: 10.777481753,
            id: 4,
          },
        ],
        lables: [
          {
            title: "Địa chỉ",
            description: "75/27, , Nguyễn Sỹ Sách, TÂN BÌNH, HỒ CHÍ MINH",
          },
          {
            title: "Loại",
            description: "Nhà hẻm 8(m)",
          },
          {
            title: "Diện tích đất",
            description: "52",
          },
          {
            title: "Diện tích sử dụng",
            description: "277,7",
          },
          {
            title: "Đơn giá đất",
            description: "81,000,000 VND / m2",
          },
          {
            title: "Tính thanh khoản",
            description: "Trung bình",
          },
          {
            title: "Nhân viên thẩm định",
            description: "Nguyễn Hồ TY Ngân",
          },
          {
            title: "Đơn vị thẩm định",
            description: "THẨM ĐỊNH GIÁ KHU VỰC TEE",
          },
          {
            title: "Ngày thẩm định",
            description: "30/5/2019",
          },
        ],
        urls: [
          {
            title: "Hồ sơ",
            url: "http://tinhocanhminh.com.vn",
          },
          {
            title: "Báo cáo thẩm định",
            url: "http://tinhocanhminh.com.vn",
          },
        ],
      },
      iconUrl:
        "https://map-api.tinhocanhminh.com.vn/static/v1/images/markers/houseMarker.png",
      showMarker: true,
    },
    {
      id: 6,
      longitude: 106.6833361331,
      latitude: 10.7770340718,
      toolTip: "1,565,250,000 VND",
      data: {
        title:
          "Căn nhà tọa lạc tại số 106/01/12/17 Đình Nghi Xuân, khu phố 3, Phường Bình Trị Đông, Quận Bình Tân, TP.HCM",
        subTitle: "1,565,250,000 VND",
        imageUrl: `/images/house.png`,
        positions: [
          {
            longitude: 106.6828523164,
            latitude: 10.7771796421,
            id: 1,
          },
          {
            longitude: 106.6831809802,
            latitude: 10.7775555511,
            id: 2,
          },
          {
            longitude: 106.6840026399,
            latitude: 10.7769974529,
            id: 3,
          },
          {
            longitude: 106.6837256232,
            latitude: 10.7767322406,
            id: 4,
          },
        ],
        lables: [
          {
            title: "Địa chỉ",
            description: "75/27, , Nguyễn Sỹ Sách, TÂN BÌNH, HỒ CHÍ MINH",
          },
          {
            title: "Loại",
            description: "Nhà hẻm 8(m)",
          },
          {
            title: "Diện tích đất",
            description: "52",
          },
          {
            title: "Diện tích sử dụng",
            description: "277,7",
          },
          {
            title: "Đơn giá đất",
            description: "81,000,000 VND / m2",
          },
          {
            title: "Tính thanh khoản",
            description: "Trung bình",
          },
          {
            title: "Nhân viên thẩm định",
            description: "Nguyễn Hồ TY Ngân",
          },
          {
            title: "Đơn vị thẩm định",
            description: "THẨM ĐỊNH GIÁ KHU VỰC TEE",
          },
          {
            title: "Ngày thẩm định",
            description: "30/5/2019",
          },
        ],
        urls: [
          {
            title: "Hồ sơ",
            url: "http://tinhocanhminh.com.vn",
          },
          {
            title: "Báo cáo thẩm định",
            url: "http://tinhocanhminh.com.vn",
          },
        ],
      },
      iconUrl:
        "https://map-api.tinhocanhminh.com.vn/static/v1/images/markers/houseMarker.png",
      showMarker: true,
    },
    {
      id: 7,
      longitude: 106.6837112165,
      latitude: 10.7778617917,
      toolTip: "1,565,250,000 VND",
      data: {
        title:
          "Căn nhà tọa lạc tại số 106/01/12/17 Đình Nghi Xuân, khu phố 3, Phường Bình Trị Đông, Quận Bình Tân, TP.HCM",
        subTitle: "1,565,250,000 VND",
        imageUrl: `/images/house.png`,
        positions: [
          {
            longitude: 106.6838664792,
            latitude: 10.7775025088,
            id: 1,
          },
          {
            longitude: 106.6843547797,
            latitude: 10.7780882802,
            id: 2,
          },
          {
            longitude: 106.684885337,
            latitude: 10.7778046194,
            id: 3,
          },
          {
            longitude: 106.6842913946,
            latitude: 10.777251134,
            id: 4,
          },
        ],
        lables: [
          {
            title: "Địa chỉ",
            description: "75/27, , Nguyễn Sỹ Sách, TÂN BÌNH, HỒ CHÍ MINH",
          },
          {
            title: "Loại",
            description: "Nhà hẻm 8(m)",
          },
          {
            title: "Diện tích đất",
            description: "52",
          },
          {
            title: "Diện tích sử dụng",
            description: "277,7",
          },
          {
            title: "Đơn giá đất",
            description: "81,000,000 VND / m2",
          },
          {
            title: "Tính thanh khoản",
            description: "Trung bình",
          },
          {
            title: "Nhân viên thẩm định",
            description: "Nguyễn Hồ TY Ngân",
          },
          {
            title: "Đơn vị thẩm định",
            description: "THẨM ĐỊNH GIÁ KHU VỰC TEE",
          },
          {
            title: "Ngày thẩm định",
            description: "30/5/2019",
          },
        ],
        urls: [
          {
            title: "Hồ sơ",
            url: "http://tinhocanhminh.com.vn",
          },
          {
            title: "Báo cáo thẩm định",
            url: "http://tinhocanhminh.com.vn",
          },
        ],
      },
      iconUrl:
        "https://map-api.tinhocanhminh.com.vn/static/v1/images/markers/houseMarker.png",
      showMarker: true,
    },
    {
      id: 8,
      longitude: 106.6843227601,
      latitude: 10.7775877627,
      toolTip: "1,565,250,000 VND",
      data: {
        title:
          "Căn nhà tọa lạc tại số 106/01/12/17 Đình Nghi Xuân, khu phố 3, Phường Bình Trị Đông, Quận Bình Tân, TP.HCM",
        subTitle: "1,565,250,000 VND",
        imageUrl: `/images/house.png`,
        positions: [
          {
            longitude: 106.6834016545,
            latitude: 10.7777907823,
            id: 1,
          },
          {
            longitude: 106.6839099097,
            latitude: 10.778348879,
            id: 2,
          },
          {
            longitude: 106.6841704932,
            latitude: 10.7781966709,
            id: 3,
          },
          {
            longitude: 106.6836000267,
            latitude: 10.777567082,
            id: 4,
          },
        ],
        lables: [
          {
            title: "Địa chỉ",
            description: "75/27, , Nguyễn Sỹ Sách, TÂN BÌNH, HỒ CHÍ MINH",
          },
          {
            title: "Loại",
            description: "Nhà hẻm 8(m)",
          },
          {
            title: "Diện tích đất",
            description: "52",
          },
          {
            title: "Diện tích sử dụng",
            description: "277,7",
          },
          {
            title: "Đơn giá đất",
            description: "81,000,000 VND / m2",
          },
          {
            title: "Tính thanh khoản",
            description: "Trung bình",
          },
          {
            title: "Nhân viên thẩm định",
            description: "Nguyễn Hồ TY Ngân",
          },
          {
            title: "Đơn vị thẩm định",
            description: "THẨM ĐỊNH GIÁ KHU VỰC TEE",
          },
          {
            title: "Ngày thẩm định",
            description: "30/5/2019",
          },
        ],
        urls: [
          {
            title: "Hồ sơ",
            url: "http://tinhocanhminh.com.vn",
          },
          {
            title: "Báo cáo thẩm định",
            url: "http://tinhocanhminh.com.vn",
          },
        ],
      },
      iconUrl:
        "https://map-api.tinhocanhminh.com.vn/static/v1/images/markers/houseMarker.png",
      showMarker: true,
    },
    {
      id: 9,
      longitude: 106.6801921582,
      latitude: 10.7814030681,
      toolTip: "1,565,250,000 VND",
      data: {
        title:
          "Căn nhà tọa lạc tại số 106/01/12/17 Đình Nghi Xuân, khu phố 3, Phường Bình Trị Đông, Quận Bình Tân, TP.HCM",
        subTitle: "1,565,250,000 VND",
        imageUrl: `/images/house.png`,
        positions: [
          {
            longitude: 106.680014313,
            latitude: 10.7809384725,
            id: 1,
          },
          {
            longitude: 106.680157345,
            latitude: 10.7820526694,
            id: 2,
          },
          {
            longitude: 106.6804484276,
            latitude: 10.7819195576,
            id: 3,
          },
          {
            longitude: 106.680187457,
            latitude: 10.7808891717,
            id: 4,
          },
        ],
        lables: [
          {
            title: "Địa chỉ",
            description: "75/27, , Nguyễn Sỹ Sách, TÂN BÌNH, HỒ CHÍ MINH",
          },
          {
            title: "Loại",
            description: "Nhà hẻm 8(m)",
          },
          {
            title: "Diện tích đất",
            description: "52",
          },
          {
            title: "Diện tích sử dụng",
            description: "277,7",
          },
          {
            title: "Đơn giá đất",
            description: "81,000,000 VND / m2",
          },
          {
            title: "Tính thanh khoản",
            description: "Trung bình",
          },
          {
            title: "Nhân viên thẩm định",
            description: "Nguyễn Hồ TY Ngân",
          },
          {
            title: "Đơn vị thẩm định",
            description: "THẨM ĐỊNH GIÁ KHU VỰC TEE",
          },
          {
            title: "Ngày thẩm định",
            description: "30/5/2019",
          },
        ],
        urls: [
          {
            title: "Hồ sơ",
            url: "http://tinhocanhminh.com.vn",
          },
          {
            title: "Báo cáo thẩm định",
            url: "http://tinhocanhminh.com.vn",
          },
        ],
      },
      iconUrl:
        "https://map-api.tinhocanhminh.com.vn/static/v1/images/markers/houseMarker.png",
      showMarker: true,
    },
    {
      id: 10,
      longitude: 106.6810504651,
      latitude: 10.7815611598,
      toolTip: "1,565,250,000 VND",
      data: {
        title:
          "Căn nhà tọa lạc tại số 106/01/12/17 Đình Nghi Xuân, khu phố 3, Phường Bình Trị Đông, Quận Bình Tân, TP.HCM",
        subTitle: "1,565,250,000 VND",
        imageUrl: `/images/house.png`,
        positions: [
          {
            longitude: 106.6807746409,
            latitude: 10.7815054317,
            id: 1,
          },
          {
            longitude: 106.6809954621,
            latitude: 10.7819984387,
            id: 2,
          },
          {
            longitude: 106.6814872914,
            latitude: 10.7816977045,
            id: 3,
          },
          {
            longitude: 106.6812815261,
            latitude: 10.7812786481,
            id: 4,
          },
        ],
        lables: [
          {
            title: "Địa chỉ",
            description: "75/27, , Nguyễn Sỹ Sách, TÂN BÌNH, HỒ CHÍ MINH",
          },
          {
            title: "Loại",
            description: "Nhà hẻm 8(m)",
          },
          {
            title: "Diện tích đất",
            description: "52",
          },
          {
            title: "Diện tích sử dụng",
            description: "277,7",
          },
          {
            title: "Đơn giá đất",
            description: "81,000,000 VND / m2",
          },
          {
            title: "Tính thanh khoản",
            description: "Trung bình",
          },
          {
            title: "Nhân viên thẩm định",
            description: "Nguyễn Hồ TY Ngân",
          },
          {
            title: "Đơn vị thẩm định",
            description: "THẨM ĐỊNH GIÁ KHU VỰC TEE",
          },
          {
            title: "Ngày thẩm định",
            description: "30/5/2019",
          },
        ],
        urls: [
          {
            title: "Hồ sơ",
            url: "http://tinhocanhminh.com.vn",
          },
          {
            title: "Báo cáo thẩm định",
            url: "http://tinhocanhminh.com.vn",
          },
        ],
      },
      iconUrl:
        "https://map-api.tinhocanhminh.com.vn/static/v1/images/markers/houseMarker.png",
      showMarker: true,
    },
  ],
  mainProperty: {
    latitude: 10.324607933,
    longitude: 106.106131705,
    iconUrl: "/images/markers/green.png",
    data: {
      positions: [
        { longitude: 106.62197113032887, latitude: 10.80986938138075, id: 1 },
        { longitude: 106.61733627315111, latitude: 10.790983880706797, id: 2 },
        { longitude: 106.6463470458459, latitude: 10.788791736768285, id: 3 },
        { longitude: 106.6578483580916, latitude: 10.807002908621325, id: 4 },
        { longitude: 106.62197113032887, latitude: 10.80986938138075, id: 5 },
      ],
    },
  },
  actions: [
    {
      iconUrl: "/images/Click-1_24px.png",
      name: "Tìm xung quanh",
      // action key when click event will contains this key
      key: "1",
    },
  ],
  settings: {
    useVn2000: true,
    usePaging: true,
    useMenu: true,
    useCenterPoint: true,
    useDefaultGeolocation: true,
    centerViewport: {
      latitude: 10.324607933,
      longitude: 106.106131705,
    },
    zoom: 14,
    //Initial values
    isColapsedLeftPanel: true,
    defaultMap: "anhminh-map",
  },
};
class Map extends React.Component {
  mapWidget = null;
  constructor(props) {
    super(props);
    const { accessToken, username } = userService.getLoginUserInfo();
    this.state = {
      accessToken,
      memberId: username,
    };
  }

  _onSetZoom = (event) => {
    dataStructure.settings = {
      ...dataStructure.settings,
      zoom: dataStructure.settings.zoom + 1,
    };
    this.mapWidget.setZoom(dataStructure.settings.zoom);
    this.forceUpdate();
  };

  _onSetCenter = (event) => {
    dataStructure.settings.centerViewport = {
      longitude: 106.62197113032887,
      latitude: 10.80986938138075,
    };
    this.mapWidget.setCenterView(
      dataStructure.settings.centerViewport.longitude,
      dataStructure.settings.centerViewport.latitude
    );
    this.forceUpdate();
  };

  _forceUpdate = () => {
    this.setState({ state: this.state });
  };
  _onTakePicture = async () => {
    const dataUrl = await this.mapWidget.takePicture({});
    console.log(dataUrl);
  };
  _onDrawMarkers = () => {};
  _onGetDirection = async () => {
    const profile = "car";
    const start = {
      latitude: 10.324607933,
      longitude: 106.106131705,
    };
    const end = {
      latitude: 11.4576935243,
      longitude: 107.414136455,
    };
    const data = await this.mapWidget.getDirectionAsync(profile, start, end);

    //marker_[color][character].png
    // color	red, black, blue, green, grey, orange, purple, white, yellow
    // character	A-Z, 1-100, !, @, $, +, -, =, (%23 = #), (%25 = %), (%26 = &), (blank = •)
    const color = "red";
    const colorEnd = "orange";
    const characterStart = "1";
    const characterEnd = "2";
    const routings = [
      {
        geojson: data,
        lineColor: "#ff4000",
        lineWidth: 3,
        markers: [
          {
            latitude: start.latitude,
            longitude: start.longitude,
            iconUrl: `/images/markers/google/marker_${color}${characterStart}.png`,
            toolTip: "1,565,250,000 VND",
            data: {
              title:
                "Căn nhà tọa lạc tại số 106/01/12/17 Đình Nghi Xuân, khu phố 3, Phường Bình Trị Đông, Quận Bình Tân, TP.HCM",
              subTitle: "1,565,250,000 VND",
              imageUrl: `/images/house.png`,
              positions: [
                {
                  longitude: 106.62197113032887,
                  latitude: 10.80986938138075,
                  id: 1,
                },
                {
                  longitude: 106.61733627315111,
                  latitude: 10.790983880706797,
                  id: 2,
                },
                {
                  longitude: 106.6463470458459,
                  latitude: 10.788791736768285,
                  id: 3,
                },
                {
                  longitude: 106.6578483580916,
                  latitude: 10.807002908621325,
                  id: 4,
                },
                {
                  longitude: 106.62197113032887,
                  latitude: 10.8098693813807,
                  id: 5,
                },
              ],
              lables: [
                {
                  title: "Địa chỉ",
                  description: "75/27, , Nguyễn Sỹ Sách, TÂN BÌNH, HỒ CHÍ MINH",
                },
                { title: "Loại", description: "Nhà hẻm 8(m)" },
                { title: "Diện tích đất", description: "52" },
                { title: "Diện tích sử dụng", description: "277,7" },
                { title: "Đơn giá đất", description: "81,000,000 VND / m2" },
                { title: "Tính thanh khoản", description: "Trung bình" },
                {
                  title: "Nhân viên thẩm định",
                  description: "Nguyễn Hồ TY Ngân",
                },
                {
                  title: "Đơn vị thẩm định",
                  description: "THẨM ĐỊNH GIÁ KHU VỰC TEE",
                },
                { title: "Ngày thẩm định", description: "30/5/2019" },
              ],
              urls: [
                { title: "Hồ sơ", url: "http://tinhocanhminh.com.vn" },
                {
                  title: "Báo cáo thẩm định",
                  url: "http://tinhocanhminh.com.vn",
                },
              ],
            },
          },
          {
            latitude: end.latitude,
            longitude: end.longitude,
            iconUrl: `/images/markers/google/marker_${colorEnd}${characterEnd}.png`,
            toolTip: "1,565,250,000 VND",
            data: {
              title:
                "Căn nhà tọa lạc tại số 106/01/12/17 Đình Nghi Xuân, khu phố 3, Phường Bình Trị Đông, Quận Bình Tân, TP.HCM",
              subTitle: "3,565,250,000 VND",
              imageUrl: `/images/house.png`,
              positions: [
                {
                  longitude: 106.62197113032887,
                  latitude: 10.80986938138075,
                  id: 1,
                },
                {
                  longitude: 106.61733627315111,
                  latitude: 10.790983880706797,
                  id: 2,
                },
                {
                  longitude: 106.6463470458459,
                  latitude: 10.788791736768285,
                  id: 3,
                },
                {
                  longitude: 106.6578483580916,
                  latitude: 10.807002908621325,
                  id: 4,
                },
                {
                  longitude: 106.62197113032887,
                  latitude: 10.8098693813807,
                  id: 5,
                },
              ],
              lables: [
                {
                  title: "Địa chỉ",
                  description: "75/27, , Nguyễn Sỹ Sách, TÂN BÌNH, HỒ CHÍ MINH",
                },
                { title: "Loại", description: "Nhà hẻm 8(m)" },
                { title: "Diện tích đất", description: "52" },
                { title: "Diện tích sử dụng", description: "277,7" },
                { title: "Đơn giá đất", description: "81,000,000 VND / m2" },
                { title: "Tính thanh khoản", description: "Trung bình" },
                {
                  title: "Nhân viên thẩm định",
                  description: "Nguyễn Hồ TY Ngân",
                },
                {
                  title: "Đơn vị thẩm định",
                  description: "THẨM ĐỊNH GIÁ KHU VỰC TEE",
                },
                { title: "Ngày thẩm định", description: "30/5/2019" },
              ],
              urls: [
                { title: "Hồ sơ", url: "http://tinhocanhminh.com.vn" },
                {
                  title: "Báo cáo thẩm định",
                  url: "http://tinhocanhminh.com.vn",
                },
              ],
            },
          },
        ],
      },
    ];
    console.log("set routings");
    this.mapWidget.setRoutings(routings);
  };

  render() {
    const { classes } = this.props;
    const onUpdateValues = (values) => {
      console.log("onUpdateValues", values);
    };
    const onPageIndexChanged = (index) => {
      console.log("onPageIndexChanged", index);
    };

    const onActionClick = (action) => {
      console.log(action);
    };

    const onCenterPointChanged = (longitude, latitude) => {
      dataStructure.settings.centerViewport.longitude = longitude;
      dataStructure.settings.centerViewport.latitude = latitude;
    };
    const onIdle = () => {
      // console.log("onIdle");
    };
    const { accessToken, memberId } = this.state;

    return (
      <div className={classes.root}>
        <Card className={classes.content}>
          <CardContent className={classes.bodyContent}>
            <div>
              <button onClick={this._onSetZoom}>Set zoom</button> |
              <button onClick={this._onSetCenter}>Set center</button> |
              <button onClick={this._onTakePicture}>Take picture</button> |
              <button onClick={this._onGetDirection}>Get Direction</button> |
              <button onClick={this._onDrawMarkers}>Draw makers</button>
            </div>
            <MapWiget
              ref={(instance) => {
                if (this.mapWidget === null) {
                  this.mapWidget = instance;
                }
              }}
              accessToken={accessToken}
              memberId={memberId}
              properties={dataStructure.properties}
              mainProperty={dataStructure.mainProperty}
              pagination={dataStructure.pagination}
              settings={dataStructure.settings}
              actions={dataStructure.actions}
              onUpdateValues={onUpdateValues}
              onPageIndexChanged={onPageIndexChanged}
              onActionClick={onActionClick}
              onCenterPointChanged={onCenterPointChanged}
              onIdle={onIdle}
            />
          </CardContent>
        </Card>
      </div>
    );
  }
}

export default withStyles(styles)(Map);
